function currencyFieldDirective() {
    'ngInject';

    return {
        restrict: 'A',
        require: 'ngModel',
        link(scope, element, attrs, ctrl) {

            const convertToCurrency = value => value / 100;

            const convertToInteger = value => value * 100;

            ctrl.$formatters.push(convertToCurrency);
            ctrl.$parsers.push(convertToInteger);
        }
    };
}

angular
    .module('BB.inputs')
    .directive('bbCurrencyField', currencyFieldDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-inputs/currency-filed/currency_field.directive.js